import { useAdmin } from '../../contexts/AdminContext';
import { resolveAuthEmail } from '../../lib/resolveAuthEmail';

export default function AdminBadge() {
  const { isAdmin, user, signingIn, signIn, signOut } = useAdmin();
  const resolvedEmail = resolveAuthEmail(user);

  const label = signingIn
    ? 'SIGNING IN…'
    : isAdmin
      ? `ADMIN · ${(resolvedEmail || user?.email || '').split('@')[0].toUpperCase()}`
      : user && !user.isAnonymous
        ? resolvedEmail
          ? `NOT AN ADMIN (${resolvedEmail})`
          : 'NOT AN ADMIN · SIGN OUT'
        : 'SIGN IN AS ADMIN';

  const handle = () => {
    if (signingIn) return;
    if (user && !user.isAnonymous) signOut();
    else signIn();
  };

  return (
    <button
      type="button"
      className={`admin-badge${isAdmin ? ' is-admin' : ''}`}
      onClick={handle}
      title={isAdmin ? 'Signed in as admin. Click to sign out.' : 'Sign in with Google to enable delete actions.'}
    >
      {label}
    </button>
  );
}
